import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
  mentions: {
    title: "Mentions légales",
    testid: "mentions-legales-page",
    body: "Contenu en préparation. Les mentions légales de Zion Solutions Suisse Sàrl seront publiées prochainement sur cette page.",
  },
  privacy: {
    title: "Politique de confidentialité",
    testid: "politique-confidentialite-page",
    body: "Contenu en préparation. La politique de confidentialité de Zion Solutions Suisse Sàrl sera publiée prochainement sur cette page.",
  },
};

export default function LegalPage({ type }) {
  const content = CONTENT[type] || CONTENT.mentions;
  return (
    <div data-testid={content.testid} className="flex min-h-screen flex-col bg-white">
      <header className="border-b border-slate-200">
        <div className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-4 sm:px-8 lg:px-16">
          <Link to="/" data-testid="legal-logo-link" className="flex flex-col leading-none">
            <span className="font-display text-[15px] font-semibold tracking-[0.08em] text-ink">
              ZION SOLUTIONS
            </span>
            <span className="mt-1 text-[10px] font-medium uppercase tracking-[0.34em] text-brand">
              Suisse Sàrl
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 transition-colors hover:text-brand"
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={1.8} />
            Retour à l’accueil
          </Link>
        </div>
      </header>
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-20 sm:px-8 lg:py-28">
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.28em] text-brand">
          Zion Solutions Suisse Sàrl
        </p>
        <h1
          data-testid="legal-page-title"
          className="font-display text-3xl font-normal tracking-tight text-ink sm:text-4xl"
        >
          {content.title}
        </h1>
        <p data-testid="legal-page-body" className="mt-8 text-base leading-relaxed text-slate-600 sm:text-lg">
          {content.body}
        </p>
        <p className="mt-6 text-base leading-relaxed text-slate-600">
          Pour toute question, contactez-nous au{" "}
          <a href="tel:+41782135944" className="font-medium text-brand hover:underline">
            +41 78 213 59 44
          </a>{" "}
          ou par e-mail à{" "}
          <a href="mailto:zionsolutions.ch@gmail.com" className="font-medium text-brand hover:underline">
            zionsolutions.ch@gmail.com
          </a>
          .
        </p>
      </main>
      <footer className="border-t border-slate-200 py-6 text-center text-xs text-slate-500">
        © 2026 Zion Solutions Suisse Sàrl — Genève
      </footer>
    </div>
  );
}
